// Sets up the globals several other modules read at their own top level
// (e.g. app/application.js, src/market_sheet.js call `$(...)` immediately,
// not inside an event listener). This must be the first import in app.js:
// ES modules evaluate all of a file's imports (in order) before running
// that file's own top-level code, so doing this inline in app.js would run
// too late for any dependency listed above it to see these globals.
import $ from 'jquery'
window.$ = window.jQuery = $

import Rails from '@rails/ujs'
window.Rails = Rails

import Sortable from 'sortablejs'
window.Sortable = Sortable

import TomSelect from 'tom-select/dist/js/tom-select.complete.js'
window.TomSelect = TomSelect

import flatpickr from 'flatpickr'
window.flatpickr = flatpickr

// mapbox-gl (~1MB) is only used on merchant/distributor map pages
// (see src/mapbox.js), so it's loaded on demand there instead of here.
